<template>
  <div
    class="block w-full"
  >
    <canvas
      ref="canvas"
      v-if="hash"
      class="absolute top-0 left-0 right-0 bottom-0 w-full h-full"
      width="32"
      height="32"
    />
    <img
      :src="src"
      :alt="alt"
      class="absolute top-0 left-0 right-0 bottom-0 w-full h-full object-cover"
    >
  </div>
</template>

<script setup>
import {decode} from 'blurhash'
import {onMounted, ref} from "vue";

const canvas = ref(null)
const props = defineProps({
  hash: {
    type: String,
    required: false
  },
  src: {
    type: String,
    required: true
  },
  alt: {
    type: String,
    required: false,
    default: ''
  }
})

onMounted(() => {
  if(props.hash) {
    const pixels = decode(props.hash, 32, 32)
    const imageData = new ImageData(pixels, 32, 32)
    const context = canvas.value.getContext('2d')
    context.putImageData(imageData, 0, 0)
  }
})
</script>